import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
// 引入bootstrap
import $ from 'jquery'
// 引入iconfont
import './assets/iconfont/iconfont.css'
// 引入基础样式
import './assets/css/base.css'
import toptitle from './components/TopTitle.vue'
import leftSidebar from './components/LeftSidebar.vue'

import tool from "./utils/tool";
Vue.use(tool);


// import axios from 'axios'
Vue.component('toptitle', toptitle)
Vue.component('leftsidebar', leftSidebar)

Vue.use(vueSwiper)

Vue.config.productionTip = false
// Vue.prototype.$http = axios.create({
//   baseURL: process.env.VUE_APP_API_URL || '/web/api'
//   // baseURL: 'http://localhost:3000/web/api'
// })

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {    
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})